export default __webpack_public_path__ + "static/media/avatar_indian_boy1.29c13bb6.mp3";